package com.trevorwiebe.timesheet

import kotlinx.serialization.Serializable


sealed interface Route {

    @Serializable
    data object SignIn : Route

    @Serializable
    data object Punch : Route

    @Serializable
    data object PayPeriod : Route

    @Serializable
    data class PayPeriodDetail(
        val startTime: String,
        val endTime: String,
        val timeSheetId: String,
        // Set by the admin Employee Hour Reports flow: which employee this pay period belongs to
        // (null = the signed-in user) and whether the admin can edit it regardless of submission.
        val userId: String? = null,
        val adminEdit: Boolean = false,
    ) : Route

    @Serializable
    data object Loads : Route

    @Serializable
    data object CompletedLoads : Route

    @Serializable
    data object Calendar :Route

    @Serializable
    data object Mileage : Route

    @Serializable
    data object More : Route

    @Serializable
    data object Admin : Route

    @Serializable
    data object Equipment : Route

    @Serializable
    data object Locations : Route

    @Serializable
    data object Customers : Route

    @Serializable
    data object Carriers : Route

    @Serializable
    data object OwnerOperators : Route

    @Serializable
    data object Reporting : Route

    @Serializable
    data object Invoicing : Route

    @Serializable
    data object Settlements : Route

    @Serializable
    data object UserManagement : Route

    @Serializable
    data object Organization : Route

    @Serializable
    data object Rates : Route

    @Serializable
    data object LoadRates : Route

    @Serializable
    data object EmployeeHours : Route

    @Serializable
    data class EmployeePayPeriods(
        val userId: String,
        val employeeName: String,
    ) : Route

}